module.exports = __webpack_public_path__ + "img/capsule-start-button-image.8a7203cc.png";